export * from './delete-kunden-art.service';
export * from './delete-kunden-art.service.module';